export const LEARNING_APPS_WITH_CREDENTIALS: string[] = ['IXL', 'Duolingo'];

export const LEARNING_APPS: Array<{ name: string, pattern: string }> = [
  { name: "Lalilo", pattern: ".*lalilo.com.*" },
  { name: 'Actively Learn', pattern: '.*read.activelylearn.com.*' },
  { name: 'ReadTheory', pattern: '.*readtheory.org.*' },
  { name: 'Albert', pattern: '.*albert.io.*' },
  { name: 'Beast Academy', pattern: '.*beastacademy.com/school.*' },
  { name: 'Brilliant', pattern: '.*brilliant.org.*' },
  { name: 'CodeCombat', pattern: '.*codecombat.com.*' },
  { name: 'CommonLit', pattern: '.*commonlit.org/.*' },
  { name: 'Comixology', pattern: '.*comixology.com/comic-reader/27697/137637.*' },
  { name: 'Codecademy', pattern: '.*codecademy.com.*' },
  { name: 'DreamBox', pattern: '.*play.dreambox.com.*' },
  { name: 'eGumpp', pattern: '.*egumpp.com.*' },
  { name: 'Freckle', pattern: '.*student.freckle.com.*' },
  { name: 'Glose', pattern: '.*glose.education/read.*' },
  { name: 'Google App Maker', pattern: '.*appmaker.google.com.*' },
  { name: 'Imagine Math', pattern: '.*math.imaginelearning.com.*' },
  { name: 'IXL', pattern: '.*ixl.com.*' },
  { name: 'Khan Academy', pattern: '.*khanacademy.org.*' },
  { name: 'Knewton', pattern: '.*knewton.com.*' },
  { name: 'Knowre', pattern: '.*knowremath.com.*' },
  { name: 'Headsprout', pattern: '.*kidsa-z.com.*(h|H)eadsprout.*' },
  { name: 'RAZ', pattern: '.*kidsa-z.com.*' },
  { name: 'Lexia Core5', pattern: '.*lexiacore5.com.*' },
  { name: 'Lexia PowerUp', pattern: '.*lexiapowerup.com.*' },
  { name: 'MATHia', pattern: '.*carnegielearning.com.*' },
  { name: 'NewsELA', pattern: '.*newsela.com.*' },
  { name: 'Tynker', pattern: '.*tynker.com.*' },
  { name: 'Pivot', pattern: '.*app.pivotinteractives.com/assignments/.*' },
  { name: 'ST Math', pattern: '.*play.stmath.com.*' },
  { name: 'Study.com', pattern: '.*study.com.*' },
  { name: 'Writable', pattern: '.*app.writable.com.*' },
  { name: 'ALEKS', pattern: '.*www-awu.aleks.com/alekscgi/.*' },
  { name: 'Middlebury', pattern: '.*app.middleburyinteractive.com/activity_lists/.*' },
  { name: 'Middlebury', pattern: '.*languages.fueleducation.com/.*' },
  { name: 'CodeHS', pattern: '.*codehs.com/.*' },
  { name: 'Labster', pattern: '.*labster.com/.*' },
  { name: 'ProWritingAid', pattern: '.*prowritingaid.com/.*' },
  { name: 'Literably', pattern: '.*literably.com/read.*' },
  { name: 'Repl', pattern: '.*repl.it/.*' },
  { name: 'Mango', pattern: '.*learn.mangolanguages.com/pathway.*' },
  { name: 'LanguageBird', pattern: '.*languagebird.*' },
  { name: 'Book Taco', pattern: '.*booktaco.com.*' },
  { name: 'Mathseeds', pattern: '.*student.mathseeds.com/.*' },
  { name: 'Reading Eggspress', pattern: '.*student.readingeggspress.com/.*' },
  { name: 'Koantum', pattern: '.*classroom.koantum.com/.*' },
  { name: 'Seneca', pattern: '.*app.senecalearning.com/.*' },
  { name: 'NoRedInk', pattern: '.*noredink.com.*' },
  { name: 'Reading Eggs', pattern: '.*student.readingeggs.com/.*' },
  { name: 'Cengage', pattern: '.*cengage.com.*|.*cengagebrain.com.*|.*cengagenow.com.*|.*webassign.net.*' },
  { name: 'StudyPug', pattern: '.*studypug.com.*' },
  { name: 'Amplify', pattern: '.*amplify.com.*' },
  { name: 'Achieve3000', pattern: '.*achieve3000.com.*' },
  { name: 'Courseware', pattern: '.*app.edmentum.com.*' },
  { name: 'Duolingo', pattern: '.*duolingo.com.*' },
  { name: 'Fiveable', pattern: '.*fiveable.me.*' },
  { name: 'UWorld', pattern: '.*apps.uworld.com.*' },
  { name: 'UltimateReviewPacket', pattern: '.*ultimatereviewpacket.com.*' },
  { name: 'AP Classroom', pattern: '.*apclassroom.collegeboard.org.*' },
  { name: 'AP Central', pattern: '.*apcentral.collegeboard.org.*' },
  { name: 'Amazon Kindle', pattern: '.*read.amazon.ca.*' },
  { name: 'Alpha Flashcard', pattern: '.*alphaflashcards.com.*' },
  { name: 'Project Read', pattern: '.*projectread.ai.*' },
  { name: 'Outlier', pattern: '.*outlier.org.*' },
  { name: 'Synthesis', pattern: '.*synthesis.com.*' },
  { name: 'XtraMath', pattern: ".*xtramath.org.*" },
  { name: 'Alphawrite', pattern: ".*alphawrite.alpha.school.*"},
  { name: "Literably", pattern: ".*literably.com.*"},
  { name: "Edulastic", pattern: ".*edulastic.com.*|.*peardeck.com.*" },
  { name: 'Mathacademy', pattern: '.*mathacademy.com.*' },
  { name: 'Rocket Math', pattern: '.*rocketmath.com.*' },
  { name: 'Amira', pattern: '.*amiralearning.com.*' },
];
